import { Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCookieValue } from "../../../cookieHelper";
import translate from "../../../i18n/translate";
import { IErrorPages } from "../../../interfaces";
import "./ErrorPage.scss";

const ErrorPage: React.FC<IErrorPages> = ({
    status,
}) => {
    let [AccessDenied, setAccessDenied] = useState(false);
    let [LoadError, setLoadError] = useState(false);
    let [invalidSession, setSessionInvalid] = useState(false);
    const [constructionPage, setConstructionPage] = useState<boolean>(false);

    useEffect(() => {
        logError(status);
    }, [status])

    const logError = (status?: number) => {
        if (status === 401) {
            setAccessDenied(true);
        }
        else if(status===30) {
            setSessionInvalid(true);
        }  else if ((status === 500) && (process.env.REACT_APP_ENVIRONMENT !== "test")) {
            setConstructionPage(true);
        } else if (((status === 406) || (status === 409) || (status === 404) || status)&& !!!invalidSession) {
            setLoadError(true);
        }
        
    }

    return (
        <div className="ErrorPage-Container">
            {AccessDenied &&
                <div className="ErrorMessage">
                    <div>
                        <img                   
                            src={window.location.origin + "/images/errorPage/error-img.png"}
                            alt="ErrorPage Illustration"
                            title="ErrorPage Illustration"
                        />                        
                    </div>
                    <div>                        
                        <h5>{translate("error_oops")} {translate("error_permission_denied")}</h5>
                        <p>{translate("noAccessl2")} <Link to="/">{translate("error_link_home")}</Link>.</p>
                        <p>{translate("error_contact_admin")}</p>
                    </div>
                </div>
            }
            {LoadError &&
                <div className="ErrorMessage">
                    <div>
                        <img                   
                            src={window.location.origin + "/images/errorPage/error-img.png"}
                            alt="ErrorPage Illustration"
                            title="ErrorPage Illustration"
                        />
                    </div>
                    <div>                        
                        <h5>{translate("error_sorry")} {translate("error_load")}</h5>
                        <p>{translate("error_clear_cache")}</p>
                        <p>{translate("noAccessl2")} <Link to="/">{translate("error_link_home")}</Link>.</p>
                        <p><b>{translate("error_having_trouble")}</b></p>
                        <p>{translate("error_contact")} <a href={`${process.env["REACT_APP_GE_SUPPORT_URL"]}/${
                    getCookieValue("ulang") === "EN" ? "en-en" : (getCookieValue("ulang") || "").toLowerCase()
                  }/contact_support`}>{translate("error_contact_cst")}</a> {translate("error_forhelp")}</p>
                    </div>
                </div>
            }

            {invalidSession &&
                <div className="ErrorMessage">
                <div>
                    <img                   
                        src={window.location.origin + "/images/errorPage/error-img.png"}
                        alt="ErrorPage Illustration"
                        title="ErrorPage Illustration"
                    />
                </div>
                <div>
                    <h5>{translate("error_sorry")} {translate("error_load")}</h5>
                    <p>{translate("myschedule_invalid_session")}</p>
                    <p>{translate("noAccessl2")} <Link to="/">{translate("error_link_home")}</Link>.</p>
                    <p>{translate("error_contact")} <a href={`${process.env["REACT_APP_GE_SUPPORT_URL"]}/${
                    getCookieValue("ulang") === "EN" ? "en-en" : (getCookieValue("ulang") || "").toLowerCase()
                  }/contact_support`}> {translate("error_contact_cst")}</a> {translate("error_forhelp")}</p>
                </div>
            </div>
            }

            {constructionPage && (process.env.REACT_APP_ENVIRONMENT !== "test") && (
                <div className="under-construction-page">
                    <Typography variant="h3" className="message-header">
                    We regret that this feature is currently unavailable. A new version is under construction.
                    </Typography>
                </div>
            )}
        </div>
    );
};

export default ErrorPage 
